import React from 'react'
import './EmptyState.css'

const EmptyState = ({ 
  title = "No data to show", 
  description = "Try adjusting your filters or check back later.",
  icon = "📊"
}) => {
  return (
    <div className="empty-state">
      <div className="empty-state-content">
        <div className="empty-state-icon">{icon}</div>
        <h3 className="empty-state-title">{title}</h3>
        <p className="empty-state-description">{description}</p>
      </div>
    </div>
  )
}

export default EmptyState 